import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.971 9.039c.054.146.133.246.291.446l1.332 1.693c.102.13.15.293.142.457a7.38 7.38 0 0 0 0 .728.687.687 0 0 1-.143.46l-1.331 1.692c-.158.2-.237.3-.291.446-.04.109-.068.29-.061.405.009.156.045.249.116.435.111.289.272.647.497 1.038.251.435.497.78.7 1.036.128.16.192.24.326.328.1.065.277.133.395.15.159.025.287.003.545-.04l2.101-.357a.48.48 0 0 1 .348.078c.131.088.266.173.403.253.21.123.38.307.471.534l.866 2.165c.103.257.154.385.262.515.08.097.234.22.346.277.151.076.258.093.47.126.332.052.755.096 1.244.096.544 0 1-.044 1.351-.096.22-.033.329-.05.484-.128.115-.058.275-.187.355-.288.11-.136.159-.268.257-.533l.804-2.165c.083-.223.246-.407.452-.529a7.26 7.26 0 0 0 .36-.227.48.48 0 0 1 .347-.078l2.101.357c.258.043.386.065.545.04.118-.017.295-.085.395-.15.134-.088.198-.168.325-.328.204-.257.45-.601.7-1.036.226-.39.387-.75.498-1.038.071-.186.107-.28.116-.435a1.183 1.183 0 0 0-.061-.405c-.055-.146-.133-.246-.291-.446l-1.332-1.692a.687.687 0 0 1-.142-.46 7.41 7.41 0 0 0 0-.727.682.682 0 0 1 .142-.457v-.002l1.332-1.692c.158-.2.236-.3.29-.446.041-.109.069-.29.062-.405-.009-.155-.045-.248-.116-.435a7.402 7.402 0 0 0-.497-1.038 8.483 8.483 0 0 0-.7-1.035c-.128-.16-.192-.24-.326-.329a1.188 1.188 0 0 0-.395-.15c-.159-.025-.287-.003-.545.04l-2.103.357a.476.476 0 0 1-.345-.077 7.26 7.26 0 0 0-.36-.228 1.044 1.044 0 0 1-.452-.529l-.804-2.164c-.098-.265-.147-.398-.256-.534-.081-.1-.24-.23-.356-.288-.155-.079-.265-.095-.484-.128A9.188 9.188 0 0 0 12 2c-.489 0-.912.044-1.243.096-.213.034-.32.05-.47.126-.113.057-.268.18-.347.277-.108.13-.16.258-.262.515l-.866 2.165c-.09.227-.26.412-.471.534-.137.08-.272.165-.403.254a.48.48 0 0 1-.348.077L5.49 5.688c-.258-.044-.386-.066-.545-.041a1.187 1.187 0 0 0-.395.15c-.134.088-.198.169-.325.329-.204.256-.45.6-.7 1.035A7.4 7.4 0 0 0 3.025 8.2c-.071.187-.107.28-.116.435-.007.116.02.296.061.405ZM16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
